import React from 'react';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { backArrow } from '../../../../assets/images';

const MFAConfirmation = ({ continueMFA = () => {}, skipMFA }) => {
  let history = useHistory()
  const role = ['CSM', 'CSMMaster'].includes(sessionStorage.getItem('role'))

  return(
    <div className=' mt-12'>
      <img src={backArrow} onClick={() => { window.location.reload() }} className='mb-3.5 cursor-pointer'/>
      <h1 className='text-xl leading-8 text-gray-900 mb-0' style={{ fontFamily: 'PT Serif', fontWeight: 700}}>Secure your account</h1>
      <p className='text-base text-gray-600 mt-6 mr-20 mb-0 w-2/3'>
          You are required to enroll in Multi-Factor Authentication (MFA) for a extra layer of protection for your account.
      </p>
      <p className='text-base text-gray-600 mt-8 mr-20 mb-0 w-96'>
          Enroll using Google Authenticator or Authy app.
      </p>
      <button
      className='bg-blue-600 text-white w-96 py-5 rounded-md text-base mt-12 font-semibold hover:bg-blue-600 focus:outline-none'
      onClick={continueMFA }
      >
      Continue
      </button>
      { !role &&
        <div
        onClick={(e) => skipMFA(e, 'mfaSkip')}
        className='mb-0 mt-6 text-gray-400  font-semibold text-base  w-max cursor-pointer border-white border-b hover:text-blue-600 hover:border-blue-600'
        style={{marginLeft : '181px'}}
        >
          Skip
      </div>}
    </div>
  )

}

export default MFAConfirmation;